import type { SxProps, Theme } from "~/common/mui";
import { C_PRIMARY_HOVER } from "./Colors";

export const iconClickablePrimarySx: SxProps<Theme> = {
  cursor: "pointer",
  display: "inline-flex",
  color: "primary.main",
  "&:hover": {
    color: C_PRIMARY_HOVER,
  },
};
